import { AnyID, Types } from '@types'
import { customAlphabet } from 'nanoid'

export const nanoid = customAlphabet('123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz')

export default function getId<T extends Types | 'default'>(type: T) {
  return `${type}_${nanoid(22)}` as Extract<AnyID | `default_${string}`, `${T}_${string}`>
}
